





















































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ConfirmModal from "@/views/company_directory/ConfirmModal.vue";
import EditCompany from "@/views/super_admin/company/EditCompany.vue";
import { Company, NavigationRailItem, NavigationSubItem } from "@/api";

@Component({
  components: {
    ConfirmModal,
    EditCompany,
  },
})
export default class CompanyDetail extends Vue {
  count = 0;
  companyId = "";
  delteConfirmation = false;
  updateCompany = false;
  deleting = false;
  expirationModal = false;
  showDatePicker = false;
  selectedExpiryDate = "";
  savingExpiry = false;

  loadingFeatures = false;
  loadingFeatureIds: Record<number, boolean> = {};
  expandedFeatures: Record<string, boolean> = {};

  get selectedCompany(): Company | null {
    return this.$store.getters["superAdmin/selectedCompany"];
  }

  get allFeatures(): NavigationRailItem[] {
    return (
      (this.$store.getters["navigation/allFeatures"] as NavigationRailItem[]) ||
      []
    );
  }

  async mounted() {
    if (this.$route.params.companyid && !this.selectedCompany) {
      await this.$store.dispatch(
        "superAdmin/selectCompany",
        this.$route.params.companyid,
      );
    }
    if (this.selectedCompany?.id) {
      await this.fetchFeatures(this.selectedCompany.id);
    }
  }

  @Watch("selectedCompany")
  async onSelectedCompanyChanged(
    newCompany: Company | null,
    oldCompany: Company | null,
  ) {
    if (newCompany?.id && newCompany.id !== oldCompany?.id) {
      await this.fetchFeatures(newCompany.id);
    }
  }

  @Watch("$route")
  async onRouteChange() {
    if (this.$route.params.companyid) {
      await this.$store.dispatch(
        "superAdmin/selectCompany",
        this.$route.params.companyid,
      );
    }
  }

  async fetchFeatures(companyId: number) {
    this.loadingFeatures = true;
    try {
      await Promise.all([
        this.$store.dispatch("navigation/fetchAllFeatures", companyId),
        this.$store.dispatch("navigation/fetchFeature", companyId),
      ]);
    } catch (error) {
      console.error("Failed to fetch features:", error);
    } finally {
      this.loadingFeatures = false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFeatureId(feature: any): number | undefined {
    const id =
      feature?.featureId ??
      feature?.id ??
      feature?.item?.featureId ??
      feature?.item?.id ??
      feature?.expansion?.featureId ??
      feature?.expansion?.id;
    return typeof id === "number" ? id : id ? Number(id) : undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFeatureLabel(feature: any): string {
    return (
      feature?.item?.label ||
      feature?.expansion?.label ||
      feature?.name ||
      feature?.label ||
      "Unknown Feature"
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFeatureIcon(feature: any): string {
    return (
      feature?.item?.icon ||
      feature?.expansion?.icon ||
      feature?.icon ||
      "mdi-view-grid"
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSecondaryLabel(feature: any): string | undefined {
    return (
      feature?.item?.secondaryLabel ||
      feature?.expansion?.secondaryLabel ||
      feature?.secondaryLabel
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFeaturePath(feature: any): string | undefined {
    return feature?.item?.rootPath || feature?.rootPath;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSubItemsText(feature: any): string | undefined {
    const subItems = feature?.expansion?.subItems;
    if (Array.isArray(subItems) && subItems.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return subItems
        .map((s: NavigationSubItem) => s.label)
        .filter(Boolean)
        .join(", ");
    }
    return undefined;
  }

  toggleSubItemsExpand(key: string) {
    this.$set(this.expandedFeatures, key, !this.expandedFeatures[key]);
  }

  isSubItemsExpanded(key: string): boolean {
    return !!this.expandedFeatures[key];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSubItems(feature: any): NavigationSubItem[] {
    return feature?.expansion?.subItems || [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getEnabledSubItemsCount(feature: any): number {
    const subItems = this.getSubItems(feature);
    return subItems.filter((s: NavigationSubItem) => s.enabled).length;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFeatureKey(feature: any, index: number): string {
    const id = this.getFeatureId(feature);
    if (id !== undefined) return `feat-${id}`;
    const label = this.getFeatureLabel(feature);
    return `feat-${label}-${index}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isFeatureLoading(feature: any): boolean {
    const id = this.getFeatureId(feature);
    return id !== undefined ? !!this.loadingFeatureIds[id] : false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isFeatureEnabled(feature: any): boolean {
    if (typeof feature?.enabled === "boolean") return feature.enabled;
    if (typeof feature?.isEnabled === "boolean") return feature.isEnabled;
    if (typeof feature?.item?.enabled === "boolean")
      return feature.item.enabled;
    if (typeof feature?.item?.isEnabled === "boolean")
      return feature.item.isEnabled;
    if (typeof feature?.expansion?.enabled === "boolean")
      return feature.expansion.enabled;
    if (typeof feature?.expansion?.isEnabled === "boolean")
      return feature.expansion.isEnabled;

    const enabledFeatures =
      (this.$store.getters["navigation/features"] as NavigationRailItem[]) ||
      [];
    const id = this.getFeatureId(feature);
    const label = this.getFeatureLabel(feature);
    const path = this.getFeaturePath(feature);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return enabledFeatures.some((ef: any) => {
      const efId = this.getFeatureId(ef);
      if (id !== undefined && efId !== undefined) {
        return id === efId;
      }
      const efPath = this.getFeaturePath(ef);
      if (path && efPath) {
        return path === efPath;
      }
      return this.getFeatureLabel(ef) === label;
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async toggleFeature(feature: any, enabled: boolean) {
    const featureId = this.getFeatureId(feature);
    const companyId = this.selectedCompany?.id;
    if (!companyId) return;

    if (!featureId) {
      this.$store.commit(
        "alert/SET_SHOW_ERROR",
        "Feature ID is missing or invalid",
        { root: true },
      );
      return;
    }

    this.$set(this.loadingFeatureIds, featureId, true);
    try {
      if (enabled) {
        await this.$store.dispatch("navigation/setCompanyFeature", {
          companyId,
          featureId,
        });
      } else {
        await this.$store.dispatch("navigation/disableCompanyFeature", {
          companyId,
          featureId,
        });
      }
      await this.$store.dispatch("navigation/fetchFeature", companyId);
    } catch (error) {
      if (error instanceof Error) {
        this.$store.commit("alert/SET_SHOW_ERROR", error.message, {
          root: true,
        });
      }
    } finally {
      this.$set(this.loadingFeatureIds, featureId, false);
    }
  }

  openExpirationModal() {
    const currentExpiry = this.selectedCompany?.expiresAt;
    if (currentExpiry && !isNaN(new Date(currentExpiry).getTime())) {
      this.selectedExpiryDate = new Date(currentExpiry)
        .toISOString()
        .substring(0, 10);
    } else {
      this.selectedExpiryDate = "";
    }
    this.expirationModal = true;
  }

  closeExpirationModal() {
    this.expirationModal = false;
  }

  async saveExpiration() {
    if (!this.selectedCompany?.id) return;
    this.savingExpiry = true;
    try {
      const expiresAt =
        this.selectedExpiryDate &&
        !isNaN(new Date(this.selectedExpiryDate).getTime())
          ? new Date(this.selectedExpiryDate).toISOString()
          : undefined;
      await this.$store.dispatch("company/setExpiration", {
        companyId: this.selectedCompany.id,
        expiresAt,
      });
      await this.$store.dispatch(
        "superAdmin/selectCompany",
        this.selectedCompany.id,
      );
      this.expirationModal = false;
    } catch (error) {
      console.error(error);
    } finally {
      this.savingExpiry = false;
    }
  }

  async deleteCompany() {
    if (!this.selectedCompany?.id) return;
    this.delteConfirmation = !this.delteConfirmation;
    this.deleting = true;
    await this.$store.dispatch(
      "superAdmin/deleteCompany",
      this.selectedCompany.id,
    );
    this.deleting = false;
    this.$router.push({ path: "/company-list" });
  }

  backToList() {
    this.$router.push({ path: "/company-list" });
  }
}
